<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col lg="6" cols="7">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block" v-if="$route.meta.breadcrumbTitle">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
        <b-col lg="6" cols="5" class="text-right">
          <base-dropdown menu-on-right
                     class="btn-neutral btn-sm"
                     tag="base-button"
                     title-tag="span"
                     title="Options"
                     menuClasses="">

        <template>
          <b-dropdown-item @click="onDelete">
            <i class="ni ni-fat-remove"></i>
            <span>Delete</span>
          </b-dropdown-item>
        </template>
      </base-dropdown>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--5">
      <div class="card mb-4">
        <!-- Card header -->
        <div class="card-header">
          <h3 class="mb-0">Checkpoint details</h3>
        </div>
        <!-- Card body -->
        <div class="card-body">
          <b-form @submit.prevent="updateItem">
          <b-row>
            <b-col lg="4">
              <div class="form-group">
                <label class="form-control-label" for="motorbike">Motorbike</label>
                <select class="form-control" v-model="model.motorbike">
                  <option v-for="motorbike in motorbikes" v-bind:key="motorbike.id" v-bind:value="motorbike.id">{{motorbike._name}}</option>
                </select>
              </div>
            </b-col>
            <b-col lg="4">
              <div class="form-group">
                <label class="form-control-label" for="date">Date</label>
                <base-input type="date" id="date" placeholder="Date" v-model="model._date" @change="dateChanged"/>
              </div>
            </b-col>
            <b-col lg="4">
              <div class="form-group">
                <label class="form-control-label" for="mileage">Mileage</label>
                <input type="number" class="form-control" id="mileage" placeholder="Mileage" v-model.number="model.km">
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="text-right">
              <base-button type="primary" native-type="submit" class="my-4" :disabled="!hasChanges">Save</base-button>
            </b-col>
          </b-row>
          </b-form>
        </div>
      </div>
    </b-container>
  </div>
</template>
<script>
  import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
  import { mapActions, mapGetters } from 'vuex';

  export default {
    name: 'starter-page',
    components: {
      RouteBreadCrumb
    },
    data() {
      return {
        model: {}
      };
    },
    async mounted() {
      await this.getCheckpoint(this.$route.params.id)
      await this.listMotorbikes()
      this.model = {
        motorbike: this.item.motorbike && this.item.motorbike._id || this.item.motorbike,
        date: this.item.date,
        _date: this.item.date && new Date(this.item.date).toInputDateFormat(),
        km: this.item.km
      }
      this.$route.meta.breadcrumbTitle = this.model._date
    },
    methods: {
      ...mapActions({
        listMotorbikes: 'motorbikes/fetch',
        getCheckpoint: 'checkpoints/show',
        editCheckpoint: 'checkpoints/edit',
        deleteCheckpoint: 'checkpoints/delete'
      }),
      async updateItem() {
        await this.editCheckpoint({ id: this.$route.params.id, data: this.model })
      },
      onDelete() {
        this.deleteCheckpoint(this.$route.params.id)
        this.$router.push({ name: 'checkpoints' })
      },
      dateChanged() {
        this.model.date = this.model._date && this.model._date.fromInputDateFormatToDate().toISOString()
      },
    },
    computed: {
      ...mapGetters({
        item: 'checkpoints/item',
        motorbikes: 'motorbikes/motorbikes'
      }),
      hasChanges () {
        let changes = 0
        const keys = [
          'motorbike',
          'date',
          'km'
        ]
        Object.keys(this.model).filter(k => keys.indexOf(k) > -1).forEach(key => {
          if (this.item[key] !== this.model[key]) {
            changes++
          }
        })
        return !!(changes)
      }
    }
  };
</script>
<style scoped>
  .starter-page {
    min-height: calc(100vh - 380px);
  }
  .dropdown {
    z-index: 1000;
  }
</style>
